<template>
    <ValidationObserver class="smsPopup" ref="form" v-slot="{handleSubmit}">
        <vs-row>
            <vs-col vs-w="12">
                <div class="ml-2 mr-2">
                    <ValidationProvider
                        vid="message"
                        :name="$t('global.message')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <label class="vs-input--label block w-full">{{ $t('global.message') }}</label>
                        <vs-textarea v-model="message"/>
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
            <vs-col vs-w="12">
                <div class="ml-2 mt-4 mr-2">
                    <ValidationProvider
                        vid="languages"
                        :name="$t('global.Languages')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <label class="vs-input--label block w-full">{{ $t('global.Languages') }}</label>
                        <v-select
                            class="w-full"
                            :clearable="false"
                            appendToBody
                            v-model="languages"
                            :options="locales.languages"
                            :calculate-position="withPopper"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
            <vs-col vs-w="12">
                <div class="text-right mt-4 ml-2 mr-2">
                    <vs-button @click="handleSubmit(send)" color="primary" type="filled">{{
                            $t('buttons.Save')
                        }}
                    </vs-button>
                </div>
            </vs-col>
        </vs-row>
    </ValidationObserver>
</template>

<script>
import vSelect from 'vue-select'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import EventBus from '@/store/eventBus'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {vSelectPosition} from "@/utils/mixins";

export default {
    props: ['popupData', 'popupType', 'popupButton'],
    mixins: [vSelectPosition],

    data() {
        return {
            message: '',
            languages: null,
            locales: {}
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },

    methods: {
        async send() {
            try {
                const data = {
                    message: this.message,
                    language: this.languages ? this.languages.value : null
                }

                if(this.popupType === 'createMessageSms') {
                    await send(this.$url['sms-message'].create, 'POST', {data})
                }

                if(this.popupType === 'updateMessageSms') {
                    data.id = this.popupData.id
                    await send(this.$url['sms-message'].update, 'PUT', {data})
                }

                EventBus.$emit('responseCreateSMSMessages')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch(error) {
                if(error.response) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }

                new ErrorHandler(error).send
            }
        },

        async getLocales() {
            try {
                const geo = await send(this.$url.geo.get, 'GET').then(data => data.data.result)
                const languages = geo.languages.map(element => ({
                    label: element.language,
                    value: element.iso_2
                }))

                this.$set(this.locales, 'languages', languages)
            } catch(e) {
                new ErrorHandler(e).send
            }
        },

        initToEdit() {
            let geo = null
            if(this.locales && this.locales.languages) {
                geo = this.locales.languages.find(element => element.value === this.popupData.language)
            }

            this.message = this.popupData.message
            this.languages = geo
        }
    },

    async mounted() {
        await this.getLocales()

        if(this.popupType === 'updateMessageSms') {
            this.initToEdit()
        }
    }
}
</script>

<style lang="scss">
.smsPopup {
    .vs-component {
        margin-bottom: 0;
    }
}
</style>
